import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import {
  arabic,
  bahasa,
  english,
  french,
  malaysian,
  portuguese,
  spanish,
  urdu,
  uzbek,
} from './config/languages';

const i18nInstance = i18n.createInstance();

const getLoadPath = () =>
  window.AssignmentAppConfig &&
  window.AssignmentAppConfig.TRANSLATIONS_CDN &&
  window.AssignmentAppConfig.TRANSLATIONS_CDN.ENABLED
    ? `${window.AssignmentAppConfig.TRANSLATIONS_CDN.PATH}/${
        window.AssignmentAppConfig.TRANSLATIONS_CDN.PROJECT
      }/{{lng}}.json`
    : `${
        window.location.origin
      }/assignment-frontend/locales/{{lng}}/{{ns}}.json`;

i18nInstance
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: [
        'cookie',
        'querystring',
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
      caches: ['cookie', 'localStorage'],
      cookieDomain:
        (window &&
          window.AssignmentAppConfig &&
          window.AssignmentAppConfig.CONTENT_DOMAIN) ||
        '.alefed.com',
    },
    backend: {
      loadPath: getLoadPath(),
    },
    fallbackLng: english.code,
    debug: false,
    ns: ['translation'],
    defaultNS: 'translation',
    nsSeparator: ':::',
    keySeparator: '::',
    interpolation: {
      escapeValue: false,
    },
  });

i18nInstance.loadLanguages([
  arabic.code,
  bahasa.code,
  spanish.code,
  french.code,
  uzbek.code,
  urdu.code,
  portuguese.code,
  malaysian.code,
]);
export default i18nInstance;
